// extracted by mini-css-extract-plugin
export default {"root":"Rating__root--1p86A","item":"Rating__item--2Jdwx","value":"Rating__value--2WHQo"};